const { mat2d, mat3, vec2 } = require('gl-matrix');

const { Viewport, Grid, Model } = require('./src'); //require('infinigrid');

const React = require('react');
const { render } = require('react-dom');

const div = document.createElement('div');

const GithubBadge = () =>
  <a href="https://github.com/infinigrid/infinigrid">
    <img style={{position: 'absolute', top: 0, right: 0, border: 0, zIndex: 100}}
         src="https://camo.githubusercontent.com/a6677b08c955af8400f44c6298f40e7d19cc5b2d/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f677261795f3664366436642e706e67"
         alt="Fork me on GitHub"
         data-canonical-src="https://s3.amazonaws.com/github/ribbons/forkme_right_gray_6d6d6d.png"
         />
  </a>

const Logo = () =>
  <h1>Infinigrid</h1>

const Toolbar = ({onFitCellInViewport, onFitMapInViewport}) =>
  <div className="toolbar">
    <button onClick={onFitCellInViewport} ><i className="fa fa-2x fa-refresh" aria-hidden="true"></i></button>
    <button onClick={onFitMapInViewport}  ><i className="fa fa-2x fa-globe"   aria-hidden="true"></i></button>
  </div>

const Identifiers = ({width, height, style, model: { map: {width: w, height: h}, transform } }) => {
  console.log(w, h);
  const points = [
  ];

  for (let r = -h;r < h;++r) {
    for (let q = -w;q <w;++q) {
      const qq = (q + w) % w;
      const rr = (r + h) % h;
      console.log(qq, rr, q, r);
      points.push([qq + rr * w, q, r]);
    }
  }
  return <svg width={width} height={height} style={style}>
    {
      points.map( ([id, q, r]) => {
        const [x, y] = vec2.transformMat2d([,,], [q, r], transform);
        return <text x={x} y={y} fontSize="48px" fill="white" textAnchor="middle">{id}</text>;
      })
    }
  </svg>
}

class Demo extends React.Component {

  constructor(props) {
    super(props);
    // tap(model => {
    //   model.map = {width: 2, height: 2, data: new Uint8Array([255,255,255,255, 255,0,0,255, 0,255,0,255, 0,0,255,255 ])};
    // }).
    this.state = {
      model: new Model().fitCellInViewport([0, 0], [0, 0, window.innerWidth, window.innerHeight]),
    };

    this.image = new Image();
    this.image.src = 'world.jpg';
    this.image.onload = () => {
      this.setState({model: this.state.model.mapFromImage(1024, 1024, this.image).fitNCellsInViewport(512, [0, 0, window.innerWidth, window.innerHeight])});
    };
  }

  render() {
    return (
      <div>
        <GithubBadge/>
        <div className="overlay" style={{zIndex: 1, display: 'none',}}>
          <Logo/>
        </div>
        <Toolbar
          onFitCellInViewport={event => this.setState({model: this.state.model.fitCellInViewport([0, 0], [0, 0, window.innerWidth, window.innerHeight])})}
          onFitMapInViewport={event => this.setState({model: this.state.model.fitMapInViewport([0, 0, window.innerWidth, window.innerHeight])})}
          />
        <Viewport model={this.state.model} onClickCell={ (q, r) => console.log(q,r) }>

          <Grid/>
        </Viewport>
      </div>
    );
  }

}

render(<Demo/>, div, () => document.body.appendChild(div));



/** WEBPACK FOOTER **
 ** ./demo.js
 **/